/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {FilterVO} from './filter-vo.model';

export class FilterDataModel {
  content: any | undefined = undefined;
  label: FilterVO | undefined = undefined;
}
